import React, { useEffect, useState } from 'react';
import arrowIconImg from '../../../../images/filledArrowIcon.png';
import arrowIconImgDisabled from '../../../../images/filledArrowIconBlack.png';
import Select from 'react-select';
import axios from 'axios';
import { API_URL } from '../../../../config/constants';
import { useSelector } from 'react-redux';
function NewModelRow({ newRow, nrIdx, onChangeNew, onChangeNewSel, onChangeNewSds, onChangeNewStdVal, onCheckNewStdVal, onChangeNewFloat, newRowsArr, modelTypes }) {
    console.log(newRow)
    const { userRank } = useSelector((state) => state.session);
    const [inputMode, setInputMode] = useState({
        modelType: false,
        modelName: false,
    });
    const [organizations, setOrganizations] = useState([]);
    const [sumDsData, setSumDsData] = useState([]);
    async function getOrg() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getOrg`);
        setOrganizations(response.data.map(el => ({ id: el.id, name: el.name })));
    };

    async function getSDS() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getSumDataStructs`);
        setSumDsData(response.data);
    }

    const [modelNames, setModelNames] = useState([]);

    useEffect(() => {
        getOrg();
        getSDS();
    }, [])

    const orgOptArr = organizations.map(el => ({ label: el.name, value: el.id }));
    const sumDsOptArr = sumDsData.map(el => ({ label: el.name, value: el.sumDsId }));
    return (
        <li className='row newRow' >
            <ul>
                <li className='col modelType'>
                    <div className='inputArea'>
                        {
                            inputMode.modelType ?
                                <input type="text" name='modelType' onChange={e => onChangeNew(e, nrIdx)} />
                                : <Select
                                    options={modelTypes}
                                    menuPlacement='auto'
                                    defaultValue={{ label: '+ 추가' }}
                                    onChange={async sel => {
                                        if (sel.value === null) {
                                            setInputMode({
                                                modelType: true,
                                                modelName: true
                                            });

                                            onChangeNewSel(sel, nrIdx, 'modelType')

                                        } else {
                                            await axios.post(`${API_URL}/android/getModelNames`, { modelType: sel.value }).then(res => {
                                                setModelNames([...res.data.map(item => ({ label: item, value: item })), { label: '직접입력', value: null }]);
                                                onChangeNewSel(sel, nrIdx, 'modelType')
                                            }).catch(err => console.error(err));
                                        }
                                    }}
                                    isSearchable={false}
                                    classNames={{
                                        control: (state) => 'control',
                                        container: (state) => 'selectBox',
                                        dropdownIndicator: (state) => 'arrow',
                                        menu: (state) => 'options',
                                        option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                        singleValue: (state) => 'singleVal',
                                        valueContainer: (state) => 'valueContainer',
                                    }}
                                    components={{
                                        DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                        IndicatorSeparator: (state) => null,
                                    }}
                                />
                        }
                    </div>
                </li>
                <li className='col modelName'>
                    <div className='inputArea'>
                        {
                            inputMode.modelName ?
                                <input type="text" name='modelName' onChange={e => onChangeNew(e, nrIdx)} />
                                : <Select
                                    options={modelNames}
                                    menuPlacement='auto'
                                    defaultValue={{ label: '' }}
                                    isDisabled={newRowsArr[nrIdx].modelType === null || newRowsArr[nrIdx].modelType.length === 0}
                                    onChange={sel => {
                                        if (sel.value === null) {
                                            setInputMode({ ...inputMode, modelName: true });
                                            onChangeNewSel(sel, nrIdx, 'modelName');
                                        } else {
                                            onChangeNewSel(sel, nrIdx, 'modelName');
                                        }
                                    }}
                                    isSearchable={false}
                                    classNames={{
                                        control: (state) => 'control',
                                        container: (state) => 'selectBox',
                                        dropdownIndicator: (state) => 'arrow',
                                        menu: (state) => 'options',
                                        option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                        singleValue: (state) => 'singleVal',
                                        valueContainer: (state) => 'valueContainer',
                                    }}
                                    components={{
                                        DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={newRowsArr[nrIdx].modelType === null || newRowsArr[nrIdx].modelType.length === 0 ? arrowIconImgDisabled : arrowIconImg} alt={'드롭다운'} /></span>,
                                        IndicatorSeparator: (state) => null,
                                    }}
                                />
                        }
                    </div>
                </li>
                <li className='col modelNo'>
                    <div className='inputArea'>
                        <input type="text" name='modelNo' onChange={e => onChangeNew(e, nrIdx)} disabled={(newRowsArr[nrIdx].modelType === null || newRowsArr[nrIdx].modelType.length === 0) || (newRowsArr[nrIdx].modelName === null || newRowsArr[nrIdx].modelName.length === 0)} />
                    </div>
                </li>
                <li className='col sumDataName'>
                    <div className='inputArea'>
                        <Select
                            options={sumDsOptArr}
                            onChange={sel => {
                                const selSdsData = sumDsData.filter(el => el.sumDsId === sel.value)[0];
                                onChangeNewSds({
                                    sumDsId: sel.value, SumDataStruct: {
                                        name: selSdsData.name,
                                        grpName: selSdsData.grpName,
                                        indexName: selSdsData.indexName,
                                        indexNo: selSdsData.indexNo,
                                    }
                                }, nrIdx);
                            }}
                            menuPlacement='auto'
                            value={sumDsOptArr.find(el => el.value === newRowsArr[nrIdx]["sumDsId"])}
                            isSearchable={false}
                            maxMenuHeight={'225px'}
                            placeholder={'공정요약'}
                            classNames={{
                                control: (state) => 'control',
                                container: (state) => 'selectBox',
                                dropdownIndicator: (state) => 'arrow',
                                menu: (state) => 'options',
                                option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                singleValue: (state) => 'singleVal',
                                valueContainer: (state) => 'valueContainer',
                                placeholder: (state) => 'placeholder'
                            }}
                            components={{
                                DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                IndicatorSeparator: (state) => null,
                            }}
                        />
                    </div>
                </li>
                <li className='col grpName'>
                    <ul>
                        {
                            newRow.SumDataStruct.grpName.map((name, idx) => {
                                return (
                                    <li className='innerCol' key={`grpName_${nrIdx}_${idx}`} style={newRow.sumDsId === null ? { height: '27px' } : { height: `${27 * newRow.SumDataStruct.indexNo[idx]}px` }}>
                                        <div className='colArea'>
                                            <p>{name}</p>
                                        </div>
                                    </li>);
                            })
                        }
                    </ul>
                </li>
                <li className='col indexName'>
                    <ul>
                        {
                            newRow.SumDataStruct.indexName.map((outerArr, outerIdx) => {
                                return (<li key={`indexName_${nrIdx}_${outerIdx}`}>
                                    <ul className='indexLevelUl'>
                                        {
                                            outerArr.map((name, innerIdx) => {
                                                return (
                                                    <li className='innerCol' key={`indexName_${nrIdx}_${outerIdx}_${innerIdx}`}>
                                                        <div className='colArea'>
                                                            <p>{name}</p>
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </li>)
                            })
                        }
                    </ul>
                </li>
                <li className='col stdVal'>
                    <ul>
                        {
                            newRow.stdVal.map((outerArr, outerIdx) => {
                                return (<li key={`stdVal_${nrIdx}_${outerIdx}`}>
                                    <ul className='indexLevelUl'>
                                        {
                                            outerArr.map((innerArr, innerIdx) => {
                                                return (
                                                    <li className='innerCol' key={`stdVal_${nrIdx}_${outerIdx}_${innerIdx}`}>
                                                        <div className='inputArea'>
                                                            <input
                                                                value={innerArr[0] !== 'None' ? innerArr[0] : ''}
                                                                onChange={e => onChangeNewStdVal(e, nrIdx, outerIdx, innerIdx, 0)}
                                                                type='number'
                                                                step={0.001}
                                                            // onBlur={onBlurStdVal}
                                                            />
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </li>)
                            })
                        }
                    </ul>
                </li>
                <li className='col okNgTolM'>
                    <ul>
                        {
                            newRow.stdVal.map((outerArr, outerIdx) => {
                                return (<li key={`okNgTolM_${nrIdx}_${outerIdx}`}>
                                    <ul className='indexLevelUl'>
                                        {
                                            outerArr.map((innerArr, innerIdx) => {
                                                return (
                                                    <li className='innerCol' key={`okNgTolM_${nrIdx}_${outerIdx}_${innerIdx}`}>
                                                        <div className='inputArea'>
                                                            <input
                                                                value={innerArr[1] !== 'None' ? innerArr[1] : ''}
                                                                onChange={e => onChangeNewStdVal(e, nrIdx, outerIdx, innerIdx, 1)}
                                                                type='number'
                                                                step={0.001}
                                                                onBlur={e => onCheckNewStdVal(e, nrIdx, outerIdx, innerIdx, 1)}
                                                            />
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </li>)
                            })
                        }
                    </ul>
                </li>
                <li className='col okNgTolP'>
                    <ul>
                        {
                            newRow.stdVal.map((outerArr, outerIdx) => {
                                return (<li key={`okNgTolP_${nrIdx}_${outerIdx}`}>
                                    <ul className='indexLevelUl'>
                                        {
                                            outerArr.map((innerArr, innerIdx) => {
                                                return (
                                                    <li className='innerCol' key={`okNgTolP_${nrIdx}_${outerIdx}_${innerIdx}`}>
                                                        <div className='inputArea'>
                                                            <input
                                                                value={innerArr[2] !== 'None' ? innerArr[2] : ''}
                                                                onChange={e => onChangeNewStdVal(e, nrIdx, outerIdx, innerIdx, 2)}
                                                                type='number'
                                                                step={0.001}
                                                                onBlur={e => onCheckNewStdVal(e, nrIdx, outerIdx, innerIdx, 2)}
                                                            />
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </li>)
                            })
                        }
                    </ul>
                </li>

                <li className='col material'>
                    <div className='inputArea'>
                        <input type="text" value={newRow.material} name='material' onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col matThickness'>
                    <div className='inputArea'>
                        <input value={newRow.matThickness} name='matThickness' onChange={e => onChangeNewFloat(e, nrIdx)} type='number' step={0.001} />
                    </div>
                </li>
                <li className='col tblHeight'>
                    <div className='inputArea'>
                        <input value={newRow.tblHeight} name='tblHeight' onChange={e => onChangeNewFloat(e, nrIdx)} type='number' step={0.001} />
                    </div>
                </li>
                <li className='col ectStart'>
                    <div className='inputArea percent'>
                        <input value={newRow.ectStart} name='ectStart' onChange={e => onChangeNewFloat(e, nrIdx)} type='number' step={0.001} />
                        <span>%</span>
                    </div>
                </li>
                <li className='col ectEnd'>
                    <div className='inputArea percent'>
                        <input value={newRow.ectEnd} name='ectEnd' onChange={e => onChangeNewFloat(e, nrIdx)} type='number' step={0.001} />
                        <span>%</span>
                    </div>
                </li>
                <li className='col boltStart'>
                    <div className='inputArea percent'>
                        <input value={newRow.boltStart} name='boltStart' onChange={e => onChangeNewFloat(e, nrIdx)} type='number' step={0.001} />
                        <span>%</span>
                    </div>
                </li>
                <li className='col boltEnd percent'>
                    <div className='inputArea'>
                        <input value={newRow.boltEnd} name='boltEnd' onChange={e => onChangeNewFloat(e, nrIdx)} type='number' step={0.001} />
                        <span>%</span>
                    </div>
                </li>
                <li className='col ect2bolt'>
                    <div className='inputArea'>
                        <input value={newRow.ect2bolt} name='ect2bolt' onChange={e => onChangeNewFloat(e, nrIdx)} type='number' step={0.001} />
                    </div>
                </li>
                <li className='col bolt2dist'>
                    <div className='inputArea'>
                        <input value={newRow.bolt2dist} name='bolt2dist' onChange={e => onChangeNewFloat(e, nrIdx)} type='number' step={0.001} />
                    </div>
                </li>
                <li className='col drawing'>
                    <div className='inputArea'>
                        <input type="text" value={newRow.drawing} name='drawing' onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col photo'>
                    <div className='inputArea'>
                        <input type="text" value={newRow.photo} name='photo' onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col report'>
                    <div className='inputArea'>
                        <input type="text" value={newRow.report} name='report' onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                <li className='col comment'>
                    <div className='inputArea'>
                        <input type="text" value={newRow.comment} name='comment' onChange={e => onChangeNew(e, nrIdx)} />
                    </div>
                </li>
                {
                    userRank <= 20 ?
                        <li className='col organization'>
                            <div className='inputArea'>
                                <Select
                                    options={orgOptArr}
                                    onChange={sel => {
                                        onChangeNewSel(sel, nrIdx, 'organization')
                                    }}
                                    menuPlacement='auto'
                                    value={orgOptArr.find(el => el.value === newRowsArr[nrIdx]["organization"])}
                                    isSearchable={false}
                                    maxMenuHeight={'225px'}
                                    placeholder={'소속'}
                                    classNames={{
                                        control: (state) => 'control',
                                        container: (state) => 'selectBox',
                                        dropdownIndicator: (state) => 'arrow',
                                        menu: (state) => 'options',
                                        option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                        singleValue: (state) => 'singleVal',
                                        valueContainer: (state) => 'valueContainer',
                                        placeholder: (state) => 'placeholder'
                                    }}
                                    components={{
                                        DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                        IndicatorSeparator: (state) => null,
                                    }}
                                />
                            </div>
                        </li> : null
                }
            </ul>
        </li>
    );
}

export default NewModelRow;